/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React, { memo, useContext } from 'react';
import { useTranslation } from '@scuf/localization';
import descriptors from '../../../../locales/en-US/descriptors';
import { CarbonDetailMeterField } from '../../../shared/Utils/Constants';
import { IDataTableColumn } from '../../../shared/MeterSavingsDetailTable/IMeterSavingsDetailTableProps';
import { convertDataForCarbonUtilitySavingsMeter } from '../../../shared/Utils/CarbonViewDetailsUtils';
import CarbonDetailTabBreakdownByMeter from '../../../shared/DetailBreakdownByMeter/CarbonDetailTabBreakdownByMeter';
import { ICarbonScopeOneSavingsByMeterDetailComponentProps } from '../../../DashboardKPIWidgets/IEnergyManagementProps';
import './CarbonScopeOneSavingsByMeterDetail.scss';
import { ConversionType } from '../../../shared/Utils/unitHandling/UnitModel';
import { ApiContext } from '../../../../context/ApiContext';

export const CarbonScopeOneSavingsByMeterDetailComponent = (
  props: ICarbonScopeOneSavingsByMeterDetailComponentProps
) => {
  const [t] = useTranslation();
  const d = descriptors.DetailedView;
  const {
    data: { emissionMeasurementUnit, breakdownByMeter },
    UtilityBillType,
    scope
  } = props;

  const apiContext = useContext(ApiContext);

  const meterSavingdata = convertDataForCarbonUtilitySavingsMeter(
    breakdownByMeter,
    emissionMeasurementUnit,
    ConversionType.CARBON,
    apiContext.showChangeWhenData
  );

  const { values, displayUnit } = meterSavingdata;
  const columnDetails: Array<IDataTableColumn> = [
    {
      className: 'datatable-column-meter',
      field: CarbonDetailMeterField.meter,
      header: scope && scope === 'scope 2' ? t(d.METERNAME) : t(d.FUELTYPE),
      sortable: true,
      initialWidth: '10%'
    },
    {
      className: 'datatable-column-utilityType',
      field: CarbonDetailMeterField.utilityType,
      header: t(d.UTILITYTYPE),
      sortable: true,
      initialWidth: '9%'
    },
    {
      className: 'datatable-column-actualConsumption',
      field: CarbonDetailMeterField.actualConsumption,
      header: t(d.ACTUALEMIS),
      sortable: true,
      initialWidth: '20%'
    },
    {
      className: 'datatable-column-baselineConsumption',
      field: CarbonDetailMeterField.baselineConsumption,
      header: t(d.PREVIOUSPERIOD),
      sortable: true,
      initialWidth: '13%'
    },
    {
      className: 'datatable-column-change',
      field: CarbonDetailMeterField.change,
      header: t(d.CHANGE),
      sortable: true,
      initialWidth: '7%'
    }
  ];
  return (
    <div className="emaas-Metersaving-details-head">
      <CarbonDetailTabBreakdownByMeter
        meterData={values}
        utilityMeasurementUnit={displayUnit}
        columnDetails={columnDetails}
        utilityType={UtilityBillType}
        emissionMeasurementUnit={emissionMeasurementUnit}
      />
    </div>
  );
};
export default memo(CarbonScopeOneSavingsByMeterDetailComponent);
